import React from "react";
import LegalDocumentPage from "../components/legal/LegalDocumentPage";
import publicLegalDocuments from "../legal/publicLegalDocuments.json";

export default function AupPage() {
  return <LegalDocumentPage document={publicLegalDocuments.aup} />;
}
